<template v-if="this.statsData">
  <b-card-body >
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Driving distance</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDistance($checkValue(this.statsData['drivingDistance'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Fuel driving average</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ (($checkValue(this.statsData.drivingDistance)/1000) / $checkValue(this.statsData.fuelUsedTotal)).toFixed(2) + ' km/l' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Average speed driving</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ ($checkValue(this.statsData['drivingDistance']) / ($checkValue(this.statsData['drivingTime']) / 3600) / 1000).toFixed(2) + ' km/h' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Average speed</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ ($checkValue(this.statsData['drivingDistance']) / ($checkValue(this.statsData['totalTime']) / 3600) / 1000).toFixed(2) + ' km/h' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Total time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['totalTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Engine time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['engineTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Engine off time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['totalTime']) - $checkValue(this.statsData['engineTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Driving time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['drivingTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Cruise time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['cruiseTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>PTO time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['ptoTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Idle time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['idleTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Over idle time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['idleThresholdTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Over speed time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['overSpeedThresholdTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Over RPM time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['overRPMThresholdTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Over torque time</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $formatDuration($checkValue(this.statsData['overTorqueThresholdTime'])) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Harsh accelerations</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['harshAccelerationThresholdTime']) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Harsh brakes</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['harshBrakes']) }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Fuel total</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['fuelUsedTotal']).toFixed(2) + ' l' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Fuel driving</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['fuelUsedDriving']).toFixed(2) + ' l' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Fuel stationary</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['fuelUsedIdle']).toFixed(2) + ' l' }}</h5>
      </b-col>
    </b-row>
    <b-row align-v="center" >
      <b-col md="auto" >
        <h3>Fuel PTO</h3>
      </b-col>
      <b-col align="right">
        <h5>{{ $checkValue(this.statsData['fuelUsedPTO']).toFixed(2) + ' l' }}</h5>
      </b-col>
    </b-row>
  </b-card-body>
</template>

<script>
export default {
  name: "stats-card",
  props: {
    statsData: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>
